import React from "react";



const Cookie = () => {
  return (

    <section className="terms-area pt-130 pb-130">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <h2 className="text-center title mb-4">Cookie Policy</h2>
            <p className="merriweather-sans text-center mb-04">This Cookie Policy explains how <b className="text-white">Diagnostica Solutions Pty Ltd</b> uses cookies and similar technologies when you visit our website at https://diagnostica.app.


            </p>
          </div>
        </div>

        <div className="terms-content">
          <div className="pt-4">
            <h5 className="fw-title">1. What Are Cookies?</h5>
            <p className="merriweather-sans mb-0">Cookies are small data files stored on your device when you visit a website. They help enhance your browsing experience, remember preferences, and enable site analytics.

            </p>
           
          </div>
          <div className="py-4">
            <h5 className="fw-title">2. Types of Cookies We Use
</h5>
            
            <ul className="merriweather-sans ps-4">
              <li className="list-circle">Essential Cookies:Necessary for core site functionality (e.g., login, token access)
</li>
              <li className="list-circle">Analytical Cookies: Help us understand website traffic and user behavior (e.g., Google Analytics)
</li>
              <li className="list-circle">Functionality Cookies: Remember user preferences and settings
</li>
              <li className="list-circle">Third-Party Cookies: From services like YouTube (video), Meta Pixel (ads), and Wallet Connect
</li>
             
            </ul>
          </div>

          <div>
            <h5 className="fw-title">3. Legal Basis for Processing</h5>
            <p className="merriweather-sans mb-0">We rely on:</p>
            <ul className="merriweather-sans ps-4">
              <li className="list-circle">User consent (for health and device data)</li>
              <li className="list-circle">Contractual necessity (for service access)</li>
              <li className="list-circle">Legitimate interest (for platform improvement and fraud prevention)</li>
              <li className="list-circle">Legal obligations (AML/KYC, data retention)</li>
            </ul>
          </div>

          <div className="py-4">
            <h5 className="fw-title">3. Managing Cookies</h5>
            <p className="merriweather-sans mb-0">You can control cookies via your browser settings:</p>
            <ul className="merriweather-sans ps-4">
              <li className="list-circle">Block or delete cookies at any time</li>
              <li className="list-circle">Disable third-party cookies
</li>
              <li className="list-circle">Note: Disabling essential cookies may affect site functionality.
</li>
              
            </ul>
          </div>
          <div className="py-2">
            <h5 className="fw-title">4. Changes to Cookie Policy</h5>
            <p className="merriweather-sans mb-0">We may update this policy to reflect changes in technology or regulation. Check this page periodically for updates.
</p>
           
          </div>
         
         
         
         
          <div className="py-2">
            <h5 className="fw-title">5. Contact Us</h5>
            <p className="merriweather-sans">Questions about cookies?:
              <a href="mailto:diag@diagnostica.app"> diag@diagnostica.app</a></p>
          </div>



        </div>
      </div>
    </section>



  );
};

export default Cookie;
